module.exports = __webpack_public_path__ + "img/folder-2.280443ec.png";